import React, { useState } from 'react'
import { connectTransfers as endpoints } from '../api_urls'
import { client } from '../utils'
import PropTypes from 'prop-types'

const PreviousButton = props => {
  let [prevButtonBusy, togglePrevButtonBusy] = useState(false)
  const handlePrevClick = () => {
    togglePrevButtonBusy(true)
    client
      .post(endpoints.getRecentTransfersEndingBefore(), {
        ending_before: props.endingBefore,
        account_id: props.accountID,
      })
      .then(resp => {
        props.updateTransfers(resp.data.data)
        props.updateStartingAfter(resp.data.starting_after)
        if (resp.data.has_more === false) {
          props.updateEndingBefore(null)
        } else {
          props.updateEndingBefore(resp.data.ending_before)
        }
        props.updateHasMoreTransfers(true)
        togglePrevButtonBusy(false)
      })
      .catch(err => {
        console.log(err)
      })
  }

  return (
    <div
      className="btn btn-myed btn-default btn-default-myed btn-sm-myed"
      onClick={() => handlePrevClick()}
    >
      {prevButtonBusy ? (
        <span className="fa-light fa-spinner fa-spin mr-2 text-muted" />
      ) : null}
      Previous
    </div>
  )
}

PreviousButton.propTypes = {
  endingBefore: PropTypes.string,
  accountID: PropTypes.string,
}

export default PreviousButton
